/**
 * Sample Code Snippets for TikTok-Style Feed
 * Short, engaging coding lessons and challenges
 */

export const sampleCodeSnippets = [
  {
    id: 'snippet1',
    title: 'Print Your Name',
    description: 'Your first Python program!',
    code: `# Type your name here
name = "Alex"
print(f"Hello, {name}!")`,
    challenge: 'Change "Alex" to your name and run it!',
    difficulty: 'beginner',
    topic: 'Python Basics',
    hashtags: ['#PythonTip', '#Beginner', '#HelloWorld'],
    authorName: 'CodeMaster',
    authorAvatar: '👨‍💻',
    likes: 1234,
    views: 5678,
    comments: 89,
    remixes: 45,
    duration: '15s',
    trending: true
  },
  {
    id: 'snippet2',
    title: 'For Loop Magic',
    description: 'Print numbers 1-10',
    code: `# The magic of loops!
for i in range(1, 11):
    print(i)`,
    challenge: 'Can you print only even numbers?',
    difficulty: 'beginner',
    topic: 'Loops',
    hashtags: ['#Loops', '#PythonTip', '#CodeChallenge'],
    authorName: 'LoopQueen',
    authorAvatar: '👑',
    likes: 2345,
    views: 8901,
    comments: 156,
    remixes: 78,
    duration: '20s',
    trending: true
  },
  {
    id: 'snippet3',
    title: 'Emoji Art',
    description: 'Make a pyramid of emojis',
    code: `# Emoji pyramid!
for i in range(1, 6):
    print('⭐' * i)`,
    challenge: 'Try different emojis!',
    difficulty: 'beginner',
    topic: 'Loops',
    hashtags: ['#Fun', '#Emoji', '#Pattern'],
    authorName: 'EmojiNinja',
    authorAvatar: '🥷',
    likes: 3456,
    views: 12000,
    comments: 234,
    remixes: 156,
    duration: '15s',
    trending: true
  },
  {
    id: 'snippet4',
    title: 'Secret Messages',
    description: 'Reverse text like a spy!',
    code: `# Spy decoder
message = "Hello"
secret = message[::-1]
print(secret)  # olleH`,
    challenge: 'Reverse your own message!',
    difficulty: 'intermediate',
    topic: 'Strings',
    hashtags: ['#StringMagic', '#Python', '#Cool'],
    authorName: 'SpyCoder',
    authorAvatar: '🕵️',
    likes: 4567,
    views: 15000,
    comments: 345,
    remixes: 234,
    duration: '25s'
  },
  {
    id: 'snippet5',
    title: 'Random Dice',
    description: 'Roll a dice in Python',
    code: `import random

# Roll the dice!
dice = random.randint(1, 6)
print(f"You rolled: {dice}")`,
    challenge: 'Make it roll twice!',
    difficulty: 'beginner',
    topic: 'Random',
    hashtags: ['#Random', '#Games', '#Fun'],
    authorName: 'GameDev',
    authorAvatar: '🎮',
    likes: 5678,
    views: 20000,
    comments: 456,
    remixes: 345,
    duration: '20s'
  },
  {
    id: 'snippet6',
    title: 'List Tricks',
    description: 'Cool things with lists',
    code: `# List magic
fruits = ['🍎', '🍌', '🍊']
print(fruits[-1])  # Last item
print(fruits[:2])  # First 2`,
    challenge: 'Add your favorite fruit!',
    difficulty: 'beginner',
    topic: 'Lists',
    hashtags: ['#Lists', '#Python', '#DataStructures'],
    authorName: 'ListWizard',
    authorAvatar: '🧙‍♂️',
    likes: 2890,
    views: 9876,
    comments: 123,
    remixes: 89,
    duration: '30s'
  },
  {
    id: 'snippet7',
    title: 'Age Calculator',
    description: 'How old will you be?',
    code: `# Future age
current_age = 10
years = 5
future_age = current_age + years
print(f"In {years} years, you'll be {future_age}!")`,
    challenge: 'Calculate YOUR future age!',
    difficulty: 'beginner',
    topic: 'Variables',
    hashtags: ['#Math', '#Variables', '#Fun'],
    authorName: 'MathWhiz',
    authorAvatar: '🔢',
    likes: 3456,
    views: 11234,
    comments: 178,
    remixes: 123,
    duration: '25s'
  },
  {
    id: 'snippet8',
    title: 'Password Checker',
    description: 'Is your password strong?',
    code: `# Check password
password = "secret123"
if len(password) >= 8:
    print("✅ Strong!")
else:
    print("❌ Too short!")`,
    challenge: 'Add more checks!',
    difficulty: 'intermediate',
    topic: 'Conditionals',
    hashtags: ['#Security', '#IfElse', '#Logic'],
    authorName: 'SecurityPro',
    authorAvatar: '🔐',
    likes: 4123,
    views: 13567,
    comments: 234,
    remixes: 167,
    duration: '35s'
  },
  {
    id: 'snippet9',
    title: 'Shopping List',
    description: 'Manage a list like a pro',
    code: `# Shopping list
items = []
items.append('🍕 Pizza')
items.append('🥤 Soda')
print(f"You have {len(items)} items")`,
    challenge: 'Add 3 more items!',
    difficulty: 'beginner',
    topic: 'Lists',
    hashtags: ['#Lists', '#Practical', '#RealWorld'],
    authorName: 'ShopBot',
    authorAvatar: '🛒',
    likes: 2345,
    views: 8901,
    comments: 145,
    remixes: 98,
    duration: '30s'
  },
  {
    id: 'snippet10',
    title: 'Temperature Converter',
    description: 'Celsius to Fahrenheit',
    code: `# Temperature magic
celsius = 25
fahrenheit = (celsius * 9/5) + 32
print(f"{celsius}°C = {fahrenheit}°F")`,
    challenge: 'Convert YOUR city temp!',
    difficulty: 'intermediate',
    topic: 'Math',
    hashtags: ['#Math', '#Conversion', '#Science'],
    authorName: 'ScienceGeek',
    authorAvatar: '🔬',
    likes: 3789,
    views: 12456,
    comments: 198,
    remixes: 134,
    duration: '25s'
  },
  {
    id: 'snippet11',
    title: 'Color Mixer',
    description: 'Mix colors with code!',
    code: `# Color mixing
colors = ['🔴', '🔵']
mixed = colors[0] + colors[1]
print(f"{colors[0]} + {colors[1]} = 🟣 Purple!")`,
    challenge: 'Mix different colors!',
    difficulty: 'beginner',
    topic: 'Strings',
    hashtags: ['#Art', '#Colors', '#Creative'],
    authorName: 'ArtistCoder',
    authorAvatar: '🎨',
    likes: 5234,
    views: 18901,
    comments: 312,
    remixes: 245,
    duration: '20s'
  },
  {
    id: 'snippet12',
    title: 'Lucky Number',
    description: 'Generate your lucky number!',
    code: `import random

# Your lucky number
lucky = random.randint(1, 100)
print(f"✨ Your lucky number is: {lucky}")`,
    challenge: 'Keep running until you get 77!',
    difficulty: 'beginner',
    topic: 'Random',
    hashtags: ['#Random', '#Fun', '#Games'],
    authorName: 'LuckyBot',
    authorAvatar: '🍀',
    likes: 4567,
    views: 16789,
    comments: 267,
    remixes: 189,
    duration: '15s'
  }
];

// Difficulty badges
export const difficultyColors = {
  beginner: '#4CAF50',
  intermediate: '#FF9800',
  advanced: '#F44336'
};

// Trending hashtags
export const trendingHashtags = [
  '#PythonTip',
  '#CodeChallenge',
  '#Beginner',
  '#Fun',
  '#Loops',
  '#Lists',
  '#StringMagic',
  '#Math',
  '#Games',
  '#Creative'
];

export default sampleCodeSnippets;
